import React from 'react';
import './PriceFilter.css';

/**
 * Price range. Empty means "no bound" — never default to a number, or the
 * filter silently hides everything above it.
 */
const PriceFilter = ({ rango, onCambiar }) => {
  const cambiar = (campo) => (e) => {
    const valor = e.target.value;
    onCambiar({ ...rango, [campo]: valor === '' ? '' : Math.max(0, Number(valor)) });
  };

  const invertido = rango.min !== '' && rango.max !== '' && Number(rango.min) > Number(rango.max);

  return (
    <div className="price-section-container">
      <h2>Precio</h2>
      <div className="price-section-box-container">
        <div className="filter-box">
          <label htmlFor="precio-minimo">Mínimo</label>
          <input
            className="boxy"
            type="number"
            id="precio-minimo"
            min="0"
            inputMode="numeric"
            placeholder="0"
            value={rango.min}
            onChange={cambiar('min')}
          />
        </div>
        <div className="filter-box">
          <label htmlFor="precio-maximo">Máximo</label>
          <input
            className="boxy"
            type="number"
            id="precio-maximo"
            min="0"
            inputMode="numeric"
            placeholder="Sin tope"
            value={rango.max}
            onChange={cambiar('max')}
          />
        </div>
      </div>
      {invertido && (
        <p className="price-section-aviso" role="alert">
          El mínimo es mayor que el máximo.
        </p>
      )}
    </div>
  );
};

export default PriceFilter;
